import { render, staticRenderFns } from "./GroupThankTile.vue?vue&type=template&id=367ee52a&"
import script from "./GroupThankTile.vue?vue&type=script&lang=js&"
export * from "./GroupThankTile.vue?vue&type=script&lang=js&"
import style0 from "./GroupThankTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports